export const INDIVIDUAL_ROLE_ID = 1
export const NCG_ROLE_ID = 2
export const RFP_ROLE_ID = 3
export const SECRETARIAT_ROLE_ID = 4
export const BRC_ROLE_ID = 5
export const BIRDLIFE_SECRETARIAT_ROLE_ID = 6

export const INDIVIDUAL_ROLE = 'individual'
export const NCG_ROLE = 'national coordination group'

const roles = [
  {value: INDIVIDUAL_ROLE_ID, label: 'Individual'},
  {value: NCG_ROLE_ID, label: 'National Coordination Group'},
  {value: RFP_ROLE_ID, label: 'Regional Focal Point'},
  {value: SECRETARIAT_ROLE_ID, label: 'Secretariat'},
  {value: BRC_ROLE_ID, label: 'BirdLife Regional Coordinator'},
  {value: BIRDLIFE_SECRETARIAT_ROLE_ID, label: 'BirdLife Secretariat'}
]

export default roles
